export default {
  namespaced: true,
  state: () => ({
    pedidos: [],
    detalhesPedidoPedido: {},
    ItensPedido: {},
    itens: {},
    totalPedido: {},
    setIsLoading: false,
    filterList: {},
  }),
  actions: {},
  mutations: {
    SET_PEDIDOS(state, data) {
      state.pedidos = data;
      persistirEstado(state);
    },
    SET_DETALHES_PEDIDO(state, data) {
      state.detalhesPedidoPedido = {
        nmr_prdido: validarEObterValor(data.nrPedido_PW),
        dt_emissao: validarEObterValor(data.dataEmissao),
        representante: validarEObterValorConcatenado(data.codRepresentante, data.nomeRepresentante),
        dt_prevista_faturamento: validarEObterValor(data.dataEntrega),
        cliente: validarEObterValorConcatenado(data.codClienteERP, data.razaoSocialCliente),
        local_entrega: validarEObterValorConcatenado(
          data.enderecoEntrega,
          data.complementoEnderEntrega,
          `Bairro ${data.bairroEntrega}`,
          `Cidade ${data.cidadeEntrega}`,
          `UF ${data.ufEntrega}`,
          `País ${data.paisEntrega}`,
        ),
        estabelecimento: validarEObterValor(data.estabelecimento),
        tipo: validarEObterValor(data.nomeTipoPedido),
        condicao_pagamento: validarEObterValor(data.nomeCondPagto),
        numero_pedido_cliente: validarEObterValor(data.nrPedidoCliente),
        pedido_representante: validarEObterValor(data.nrPedidoRepres),
        tipo_frete: validarEObterValor(data.tipoFrete),
        transportadora: validarEObterValor(data.nomeTransportadora),
      };
      persistirEstado(state);
    },
    SET_ITENS_PEDIDO(state, data) {
      state.itens = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
      persistirEstado(state);
    },
    SET_FILTROS(state, data) {
      state.filterList = data;
      persistirEstado(state);
    },
    ITENS_PEDIDO(state, data) {
      state.ItensPedido = data;
    },
    TOTAL_PEDIDO(state, data) {
      state.totalPedido = data;
    },
  },
  getters: {
    getPedidos: (state) => state.pedidos,
    getIsLoading: (state) => state.setIsLoading,
    getFilterList: (state) => state.filterList,
    getDetalhesPedidoPedido: (state) => state.detalhesPedidoPedido,
    getItensPedido: (state) => state.ItensPedido,
    getTotalPedido: (state) => state.totalPedido,
    getItens: (state) => state.itens,
  },
};

function validarEObterValor(valor) {
  return (valor !== undefined && valor !== null) ? valor : '';
}

function validarEObterValorConcatenado(...valores) {
  const valoresValidos = valores.filter((valor) => valor !== undefined && valor !== null);
  return (valoresValidos.length > 0) ? valoresValidos.join(' ') : '';
}

function persistirEstado(state) {
  localStorage.setItem('estado', JSON.stringify(state));
}
